import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=393379c8&scoped=true&"
import script from "./LeftAside.vue?vue&type=script&lang=js&"
export * from "./LeftAside.vue?vue&type=script&lang=js&"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=393379c8&prod&lang=scss&scoped=true&"
import style1 from "./LeftAside.vue?vue&type=style&index=1&id=393379c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393379c8",
  null
  
)

export default component.exports